const states = {
  stepWiseUserData: {
    stepZero: {},
    stepUploadImages: {
      isAllImagesUploaded: false,
      files: [],
      isGeneratedKey: false,
    },
    stepSelectModel: {
      selectedModel: null,
    },
    stepSelectBackground: {
      selectedBackground: null,
    },
    stepGenerateImage: {
      generatedResponse: [],
    },
    isGeneratedClicked: false,
  },

  myImagesForDownload: {
    generatedImages: [],
    manualEditingImages: [],
  },
};

export default states;
